const l = {
  "base.and": "ir",
  "base.toc": "Taisyklės ir sąlygos",
  "base.privacyPolicy": "Privatumo politika",
  "base.createAccount": "Sukurti paskyrą",
  "base.signin": "Prisijungti",
  "base.signup": "Registruotis",
  "base.logOut": "Atsijungti",
  "authentication.description": "Prisijunkite arba susikurkite paskyrą",
  "invitation.wrongEmailTitle": "Jau esate prisijungę",
  "invitation.wrongEmailText":
    "Panašu, kad jau esate prisijungę prie kitos paskyros. Atsijunkite ir bandykite dar kartą.",
  "invitation.invalidLinkTitle": "Neteisingas kvietimas",
  "invitation.invalidLinkText": "Kvietimo nuoroda yra neteisinga",
  "invitation.completeSignup": "Užbaikite registraciją į ",
  "invitation.completeSignupDescription":
    "Jūsų el. paštu išsiųstas patvirtinimo laiškas. Jei jo nematote gautuosiuose, patikrinkite šlamšto aplanką.",
  "invitation.completeSignupButton": "Užbaigti registraciją",
  "invitation.mustSignupTitle": "Kviečiame prisijungti prie ",
  "invitation.signInToAccept":
    "Prisijunkite, norėdami priimti kvietimą. Kvietimo laiške rasite laikiną slaptažodį.",
  "invitation.acceptTermsOnSignup": "Prisijungdami automatiškai sutinkate su mūsų",
  "invitation.accept": "Prisijunkite ir priimkite kvietimą",
  "invitation.failed":
    "Nepavyko priimti kvietimo. Bandykite atsijungti ir vėl prisijungti – arba paprašykite administratoriaus pakviesti jus dar kartą.",
  "invitation.accepted": "Kvietimas priimtas",
  "invitation.emailNotVerified":
    "El. paštas nepatvirtintas. Patvirtinkite savo el. paštą ir bandykite dar kartą.",
  "country.venezuela": "Venesuela",
  "country.japan": "Japonija",
  "country.algeria": "Alžyras",
  "country.france": "Prancūzija",
  "country.spain": "Ispanija",
  "country.china": "Kinija",
  "country.usa": "JAV",
  "country.england": "Anglija",
  "country.brazil": "Brazilija",
  "country.italy": "Italija",
  "country.denmark": "Danija",
  "head.title": "Talkio AI | Praktikuok kalbas su AI",
  "landing.title1": "Praktikuok ",
  "landing.title2": "kalbą ",
  "landing.title3": "su DI ",
  "landing.subtitle1":
    "Pažangiausia kalbų mokymosi programėlė, kurioje naudojama dirbtinis intelektas, padedantis tobulinti jūsų žodinius įgūdžius.",
  "landing.button.freeTrial": "7 dienos nemokamai",
  "landing.creditCardNotice": "Reikalinga kredito kortelė – galite atšaukti bet kada",
  "landing.text.voiceControlTeam": "Iš „Voice Control for ChatGPT“ kūrėjų komandos",
  "landing.text.trustedBy": "Daugiau nei 500 000 naudotojų pasitiki mūsų sprendimu",
  "landing.card.title.advancedAI": "Veikia su pažangiu DI",
  "landing.card.text.advancedAI":
    "Talkio AI pasitelkia pažangų dirbtinį intelektą ir leidžia bendrauti balsu, kad treniruotumėte savo kalbėjimo gebėjimus.",
  "landing.card.title.multipleLanguages": "Daugybė kalbų",
  "landing.card.text.multipleLanguages":
    "Siūlome įvairias kalbų parinktis, įskaitant anglų, kinų, prancūzų ir dar daug kitų kalbų.",
  "landing.card.title.premiumVoice": "Pažangi balsų technologija",
  "landing.card.text.premiumVoice":
    "Talkio AI siūlo aukštos kokybės balsus bei palaiko kelis populiariausių kalbų dialektus. Su mūsų kalbų technologija galite pasinerti į autentiškas pokalbio situacijas ir išmokti jums svarbiausių dialektų.",
  "landing.sectionTitle.meetTutors": "Susipažinkite su DI mokytojais",
  "landing.sectionText.moreThanTutors":
    "Talkio AI turi daugiau nei 400 DI mokytojų su išskirtinėmis dirbtinėmis asmenybėmis, pasiruošusių jums padėti mokytis kalbų.",
  "landing.text.andManyMore": "Ir dar daugybė kitų",
  "landing.text.learnWithAITutors": "Mokykitės kartu su DI mokytojais",
  "landing.text.wonderedAboutTutor":
    "Ar kada nors susimąstėte, kaip būtų turėti asmeninį kalbų mokytoją, kuris visada pasirengęs padėti? Talkio AI tai paverčia realybe. Mūsų DI mokytojai – puikūs pagalbininkai tobulinant jūsų žodinius įgūdžius. Su pažangia dirbtinio intelekto technologija jie imituoja tikrą žmogišką pokalbį ir suteikia įtraukiantį bei efektyvų kalbų mokymosi potyrį.",
  "landing.text.rememberLanguageLearning":
    "Nepamirškite – kalbų mokymasis tai ne tik gramatika ir žodynas; svarbiausia išmokti laisvai išreikšti save. Su Talkio AI išmaniais mokytojais galite kalbėti, praktikuotis ir siekti savo kalbų tikslų!",
  "landing.sectionTitle.featureSpotlight": "Funkcijų akcentas",
  "landing.sectionText.featureSpotlight":
    "Atraskite mūsų funkcijas, kurios pavers jūsų kalbų mokymąsi įtraukiančia ir įdomia kelione.",
  "landing.text.safeEnvironment": "Saugi ir palaikanti aplinka",
  "landing.text.supportiveEnvironment":
    "Mūsų programėlė suteikia jums saugią ir palaikančią aplinką, kur galite drąsiai praktikuoti kalbėjimą. Su Talkio AI galite turėti prasmingus pokalbius, pasitelkdami DI technologiją ir lavinti laisvumą bei saviraišką nauja kalba.",
  "landing.sectionTitle.insights": "Įžvalgos",
  "landing.sectionText.realStories": "Tikros istorijos iš Talkio AI naudotojų",
  "landing.sectionTitle.faq": "Dažniausiai užduodami klausimai",
  "landing.sectionText.faq": "Atsakymai į dažniausius klausimus apie Talkio AI",
  "landing.sectionTitle.pricing": "Kainodara",
  "landing.sectionText.unlockPotential":
    "Atskleiskite savo kalbų galimybes su Talkio. Jūsų kelionė į meistrystę prasideda dabar.",
  "landing.sectionText.offersForPartners": "Taip pat siūlome planus mokykloms ir komandoms",
  "landing.imageAlt.landing": "Titulinis vaizdas",
  "landing.imageAlt.laurelLeft": "Kairioji laurų šaka",
  "landing.imageAlt.laurelRight": "Dešinioji laurų šaka",
  "landing.imageAlt.speakingWithAI": "Moteris kalbasi su DI",
  "testimonial.text1":
    "Asmeniškai naudojau Talkio AI, norėdama tobulinti ispanų kalbą, ir galiu pasakyti – tai nuostabi galimybė.",
  "testimonial.text2":
    "Talkio AI – įspūdingas įrankis ir turėtų būti kiekvieno kalbų mokinio įrankių rinkinyje.",
  "testimonial.text3": "Šis Talkio AI įrankis stebina mane dėl kalbų mokymosi galimybių.",
  "testimonial.text4": "Talkio AI – tai puikus produktas.",
  "feature.lifeLikeConversations": "Gyvi pokalbiai su DI mokytojais",
  "feature.pronunciationTool": "Tariamosios praktikos įrankis",
  "feature.detailedFeedback": "Išsami grįžtamoji informacija apie kalbėjimo įgūdžius",
  "feature.interactiveWordbook": "Interaktyvus žodynėlis",
  "feature.supportsLanguages": "Daugiau nei 40 kalbų palaikymas",
  "landing.text.voiceConversations": "Balsiniai pokalbiai",
  "landing.text.voiceConversationsDescription": "Įdomūs balsiniai pokalbiai su mūsų DI mokytojais",
  "landing.text.pronunciation": "Tariama",
  "landing.text.pronunciationDescription":
    "Vertinkite ir tobulinkite tarimą, gaukite grįžtamąją informaciją apie kiekvieną žodį",
  "landing.text.feedback": "Grįžtamasis ryšys",
  "landing.text.feedbackDescription":
    "Gaukite momentinę atsiliepimą apie savo kalbėjimo įgūdžius bei patarimus, kaip tobulėti",
  "landing.text.multipleLanguages": "Kelios kalbos ir dialektai",
  "landing.text.multipleLanguagesDescription":
    "Rinkitės iš 134 kalbų ir dialektų, kad lavintumėte savo kalbėjimo gebėjimus",
  "landing.text.progress": "Progresas",
  "landing.text.progressDescription":
    "Stebėkite savo pažangą ir gaukite savaitines ataskaitas apie mokymosi eigą",
  "landing.text.wordbook": "Žodynėlis",
  "landing.text.wordbookDescription": "Išsaugokite ir kartokite išmoktus žodžius mokymosi metu",
  "landing.text.streaks": "Serijos",
  "landing.text.streaksDescription": "Sekite savo pažangą ir ugdykite mokymosi įprotį su serijomis",
  "landing.text.crosstalk": "Kryžminiai pokalbiai",
  "landing.text.crosstalkDescription":
    "Bendraukite su mokytoju tiek savo gimtąja, tiek mokomąja kalba",
  "landing.text.translations": "Vertimai",
  "landing.text.translationsDescription": "Momentiniai vertimai jūsų pokalbiams palengvinti",
  "landing.text.featureSpotlight": "Funkcijų akcentas",
  "landing.text.featureSpotlightDescription":
    "Naršykite mūsų funkcijų rinkinį, skirtą įtraukiam ir motyvuojančiam kalbų mokymui",
  "feature.practiceSpeaking.title": "Kalbėjimo praktika",
  "feature.practiceSpeaking.bullet1": "Gyvi pokalbiai su DI mokytoju",
  "feature.practiceSpeaking.bullet2": "Pirmiausia balsu grįstas bendravimas",
  "feature.practiceSpeaking.bullet3": "Pagalba pokalbyje",
  "feature.practiceSpeaking.bullet4": "Kartojimas ir taisymas",
  "feature.worldOfLanguages.title": "Kalbų pasaulis",
  "feature.worldOfLanguages.bullet1": "Daugiau nei 40 kalbų palaikymas",
  "feature.worldOfLanguages.bullet2": "Momentiniai vertimai",
  "feature.worldOfLanguages.bullet3": "Daugiakalbė kalbos atpažinimo sistema",
  "feature.worldOfLanguages.bullet4": "Rašmenų romanizacija",
  "feature.actionableFeedback.title": "Praktiškas grįžtamasis ryšys",
  "feature.actionableFeedback.bullet1": "Sakinio įvertinimas",
  "feature.actionableFeedback.bullet2": "Tobulėjimo strategijos",
  "feature.actionableFeedback.bullet3": "DI siūlymai",
  "feature.actionableFeedback.bullet4": "Kalbos tikslumo įvertinimas",
  "feature.pronunciationPractice.title": "Tariamosios praktika",
  "feature.pronunciationPractice.bullet1": "Vertinimas pagal kiekvieną žodį",
  "feature.pronunciationPractice.bullet2": "Tariamosios įgūdžių įvertinimas",
  "feature.pronunciationPractice.bullet3": "Tikslumo, pilnumo ir laisvumo vertinimas",
  "feature.pronunciationPractice.bullet4": "Kartojimas ir taisymas",
  "feature.interactiveWordbook.title": "Interaktyvus žodynėlis",
  "feature.interactiveWordbook.bullet1": "Sekite išmoktus žodžius",
  "feature.interactiveWordbook.bullet2": "Pakartotinis įsiminimas per mokytojo pasikartojimus",
  "feature.interactiveWordbook.bullet3": "Vertimas ir garsinis skaitymas",
  "feature.interactiveWordbook.bullet4": "Pavyzdiniai sakiniai",
  "feature.button.startTrial": "Pradėkite nemokamą bandomąjį laikotarpį",
  "faq.question1": "Ar yra nemokamas planas?",
  "faq.answer1":
    "Ne, visi planai mokami. Tačiau yra 7 dienų nemokamas bandomasis laikotarpis, kurį galite atšaukti bet kuriuo metu. Jokių įsipareigojimų.",
  "faq.question2": "Kas yra Talkio AI kūrėjai?",
  "faq.answer2.part1": "Talkio AI yra",
  "faq.answer2.part2":
    "produktas, registruotas Europos Sąjungoje. Aidia ApS laikosi Bendrojo duomenų apsaugos reglamento (GDPR), kad užtikrintų visų naudotojų saugumą ir privatumą.",
  "faq.question3": "Ar Talkio AI tinka pradedantiesiems?",
  "faq.answer3":
    "Talkio AI geriausiai tinka turintiems bazinių kalbos žinių ir norintiems tobulinti žodinius įgūdžius. Pradedantiesiems sukūrėme įvadinį vadovą, kuris padės pradėti. Jame aptariami pagrindiniai pasirinktos kalbos aspektai, suteikiant pagrindą išnaudoti visas Talkio AI galimybes. Vadovas yra nemokamas ir puikiai tinka besimokantiesiems nuo pradžių. Išbandykite jį ir sparčiai tobulėkite!",
  "faq.button.gettingStartedGuide": "Išbandyti NEMOKAMĄ pradžios vadovą",
  "faq.question4": "Ar mokėjimai yra saugūs?",
  "faq.answer4":
    "Taip, naudojame Stripe platformą finansiniams mokėjimams. Jūsų kredito kortelės duomenų nesaugome.",
  "faq.question5": "Kur saugomi mano duomenys?",
  "faq.answer5":
    "Jūsų duomenys saugomi Europos Sąjungoje esančiuose serveriuose: Microsoft (balsas ir duomenys), Auth0 (autentifikacija), Stripe (mokėjimai). Be to, DI funkcijoms naudojamės OpenAI, Anthropic ir Groq paslaugomis, kurių duomenys apdorojami Jungtinėse Valstijose.",
  "faq.question6": "Ar galiu susigrąžinti pinigus?",
  "faq.answer6":
    "Nemokamą bandomąjį laikotarpį galite atšaukti bet kada, tačiau jei pamiršote tai padaryti, galime grąžinti pinigus per 14 dienų, jei pasibaigus bandomajam laikotarpiui nenaudojote paslaugos. Kreipkitės į support@talkio.ai",
  "faq.question7": "Kokius mokėjimo būdus priimate?",
  "faq.answer7":
    "Prenumeratai priimame visas pagrindines kreditines korteles ir Paypal. Vienkartiniams pirkiniams taip pat priimame WeChat, Przelewy24, Giropay, Alipay ir daugiau. Galimi mokėjimo būdai priklauso nuo jūsų vietovės.",
  "faq.question8": "Ar Talkio turi mobiliąją programėlę?",
  "faq.answer8":
    "Talkio yra progresyvi internetinė programėlė – ją galite įdiegti iš naršyklės, be „App Store“ ar „Google Play“. Naudodami Talkio per naršyklę Android įrenginyje, užsiregistravę rasite įdiegimo mygtuką. iOS įrenginyje atsidarykite Talkio per Safari, spauskite dalinimosi piktogramą ir pasirinkite „Pridėti prie pagrindinio ekrano“ – programėlė įsirašys kaip įprasta mobilioji programa.",
  "faq.question9": "Kokias naršykles galiu naudoti?",
  "faq.answer9":
    "Talkio AI veikia visose šiuolaikinėse naršyklėse: Chrome, Firefox, Safari, Edge. Taip pat veikia mobiliuosiuose įrenginiuose (iPhone ir Android).",
  "faq.question10": "Kokius DI modelius naudojate?",
  "faq.answer10":
    "Talkio AI naudoja įvairius OpenAI, Anthropic ir Meta dirbtinio intelekto modelius. Kiekvienas modelis atlieka tam tikrą užduotį ir kartu sukuria galingą DI mokytoją.",
  "faq.question11": "Kuo Talkio AI skiriasi nuo Voice Control for ChatGPT?",
  "faq.answer11":
    "Talkio AI siūlo integruotą ChatGPT patirtį, pritaikytą kalbų mokymuisi. Taip pat čia gausu papildomų funkcijų, tokių kaip tarimo vertinimas, aukštos kokybės balsai, daugiakalbė parama, paruoštos mokymo medžiagos, integruotas grįžtamasis ryšys ir vertimai.",
  "faq.question12": "Kaip su jumis susisiekti?",
  "faq.answer12": "Laukiame jūsų laiško adresu hello@talkio.ai",
  "layout.serviceBar.text": "Įkurta Danijoje. Gerbiame jūsų privatumą.",
  "layout.serviceBar.community": "Prisijunkite prie pasaulinės kalbų besimokančių bendruomenės",
  "layout.nav.pricing": "Kainos",
  "layout.nav.faq": "DUK",
  "layout.nav.languages": "Kalbos",
  "layout.nav.blog": "Tinklaraštis",
  "layout.nav.schools": "Mokykloms",
  "layout.nav.teams": "Komandoms",
  "layout.nav.affiliateProgram": "Partnerių programa",
  "layout.nav.signIn": "Prisijungti",
  "layout.nav.goToApp": "Eiti į programėlę",
  "layout.nav.menu": "Meniu",
  "layout.cta.description":
    "Pažangiausia kalbų mokymosi programėlė, kurioje naudojama DI norint tobulinti žodinius įgūdžius.",
  "layout.cta.button": "Išbandykite Talkio AI",
  "layout.footer.pages": "Puslapiai",
  "layout.footer.links": "Nuorodos",
  "layout.footer.learningHub": "Mokymosi centras",
  "layout.footer.faq": "DUK",
  "layout.footer.blog": "Tinklaraštis",
  "layout.footer.partners": "Partneriai",
  "layout.footer.tools": "Įrankiai",
  "layout.footer.about": "Apie",
  "layout.footer.affiliateProgram": "Partnerių programa",
  "layout.footer.schools": "Talkio mokykloms",
  "layout.footer.teams": "Talkio komandoms",
  "layout.footer.languageGuide": "Nemokamas kalbų vadovas",
  "layout.footer.termsConditions": "Taisyklės ir sąlygos",
  "layout.footer.privacyPolicy": "Privatumo politika",
  "layout.footer.logout": "Atsijungti",
  "layout.footer.login": "Prisijungti",
  "layout.footer.blogPosts": "Tinklaraščio įrašai",
  "layout.footer.blogPost1": "Nauja funkcija Talkio AI: Interaktyvus kalbų vadovas",
  "layout.footer.blogPost2": "Talkio integruoja tris naujus individualius GPT modelius",
  "layout.footer.blogPost3":
    "Pagerinkite savo IELTS kalbėjimo įgūdžius su Talkio AI: žingsnis po žingsnio",
  "layout.footer.blogPost4": "3 veiksmingi būdai tobulinti anglų kalbėjimo įgūdžius",
  "layout.footer.blogPost5": "Kaip puikiai išlaikyti anglų kalbos testus",
  "layout.footer.blogPost6": "Sėkmė TOEFL kalbėjimo skyriuje su Talkio AI: esminis vadovas",
  "layout.footer.contact": "Kontaktai",
  "layout.footer.rights": "Visos teisės saugomos.",
  "layout.footer.illustrationCredits": "Pagrindinio puslapio iliustracijos – vectorjuice",
  "pricing.description.perMonthBilledOnce": "per mėnesį – sąskaita už visą laikotarpį",
  "pricing.description.perMonthBilledQuarterly": "per mėnesį – sąskaita kas 3 mėnesius",
  "pricing.description.perMonthBilledBiannually": "per mėnesį – sąskaita kas 6 mėnesius",
  "pricing.description.perMonthBilledYearly": "per mėnesį – sąskaita kasmet",
  "pricing.description.perMonth": "per mėnesį",
  "pricing.button.buyNow": "Įsigykite dabar – 7 dienų pinigų grąžinimo garantija",
  "pricing.button.startFreeTrial": "Pradėkite nemokamą bandomąjį laikotarpį",
  "pricing.features.refund": "7 dienų pilnas pinigų grąžinimas – galite atšaukti bet kada",
  "pricing.features.freeTrial":
    "7 dienų nemokamas bandomasis laikotarpis – galite atšaukti bet kada",
  "pricing.features.supportsLanguages": "Daugiau nei 40 kalbų palaikymas",
  "pricing.features.voiceConversations": "Gyvi balsiniai pokalbiai",
  "pricing.features.instantFeedback": "Momentinė grįžtamoji informacija",
  "pricing.features.weeklyProgressReport": "Savaitinė pažangos ataskaita",
  "pricing.features.pronunciationPractice": "Tariamosios praktika",
  "pricing.features.interactiveWordbook": "Interaktyvus žodynėlis",
  "pricing.features.speechRecognition": "Daugiakalbė kalbos atpažinimo funkcija",
  "pricing.features.extraFeatures": "Vaidmenų žaidimas, temos, viktorinos ir dar daugiau!",
  "accessRequest.pageNotExist": "404 Puslapis nerastas.",
  "accessRequest.createAccountTitle": "Sukurkite paskyrą norėdami pradėti",
  "accessRequest.createAccountMessage":
    "Norėdami prisijungti, pirmiausia turite susikurti paskyrą. Užsiregistravę galėsite pateikti prašymą patekti į sistemą.",
  "accessRequest.createAccountButton": "Sukurti paskyrą",
  "accessRequest.alreadyHaveAccount": "Jau turite paskyrą?",
  "accessRequest.signIn": "Prisijunkite",
  "accessRequest.grantedTitle": "Sveikiname!",
  "accessRequest.grantedMessage":
    "Jums suteikta prieiga prie {serviceName}. Spauskite žemiau ir pradėkite naudotis programėle.",
  "accessRequest.goToApp": "Eiti į programėlę",
  "accessRequest.accountExists": "Paskyra jau egzistuoja",
  "accessRequest.accountExistsMessage":
    "Ši paskyra jau naudojama. Jei norite tęsti, atsijunkite ir registruokitės su kitu el. paštu.",
  "accessRequest.logOut": "Atsijungti",
  "accessRequest.requestAccessTitle": "Pateikite prašymą gauti prieigą",
  "accessRequest.requestAccessMessage":
    "Jūsų prašymas turi būti patvirtintas, prieš jums gaunant prieigą.",
  "accessRequest.checkBackLater": "Vėliau patikrinkite, ar jau suteikta prieiga.",
  "accessRequest.submitRequest": "Siųsti prašymą",
  "accessRequest.pending": "Prieigos prašymas pateiktas",
};

export default l;
